import React from 'react';
import { Linkedin, Facebook, Twitter, Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const companyLinks = [
    { name: 'About Us', href: '#' },
    { name: 'Projects', href: '#' },
    { name: 'Careers', href: '#' },
    { name: 'Quality Policy', href: '#' },
  ];

  const servicesLinks = [
    { name: 'Metal Roofing', href: '#' },
    { name: 'Structural Steel', href: '#' },
    { name: 'Custom Fabrication', href: '#' },
    { name: 'On-Site Erection', href: '#' },
  ];

  return (
    <footer className="bg-[#364A9A] text-white py-10 font-poppins">
      <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-x-8 lg:gap-x-16 gap-y-8">
        {/* Column 1: Logo and Tagline */}
        <div className="flex flex-col items-start">
          <h3 className="text-xl sm:text-2xl font-bold mb-2">
            MK Metal <span className="text-[#ECEE07]">Engineering</span> Works SDN.BHD
          </h3>
          <p className="text-gray-300 text-sm">
            Precision, Safety, and Structural Integrity
          </p>
        </div>

        {/* Column 2: Company Links */}
        <div>
          <h3 className="text-lg sm:text-xl font-semibold mb-4">Company</h3>
          <ul className="space-y-2">
            {companyLinks.map((link) => (
              <li key={link.name}>
                <a href={link.href} className="text-gray-300 hover:text-[#ECEE07] transition-colors duration-300">
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Column 3: Services Links */}
        <div>
          <h3 className="text-xl font-semibold mb-4">Services</h3>
          <ul className="space-y-2">
            {servicesLinks.map((link) => (
              <li key={link.name}>
                <a href={link.href} className="text-gray-300 hover:text-[#ECEE07] transition-colors duration-300">
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Column 4: Connect & Contact Information */}
        <div>
          <h3 className="text-xl font-semibold mb-4">Connect</h3>
          <div className="flex space-x-4 mb-6">
            <a href="https://www.facebook.com/Mkmetalandengineeringworks" className="text-gray-300 hover:text-[#ECEE07] transition-colors duration-300"><Facebook size={24} /></a>
            <a href="#" className="text-gray-300 hover:text-[#ECEE07] transition-colors duration-300"><Linkedin size={24} /></a>
            <a href="#" className="text-gray-300 hover:text-[#ECEE07] transition-colors duration-300"><Twitter size={24} /></a>
          </div>
          <div className="space-y-2 text-gray-300 text-sm">
            <p className="flex items-center"><Phone size={18} className="mr-2 text-[#ECEE07]" /> +60 12 298 6592</p>
            <p className="flex items-center"><Mail size={18} className="mr-2 text-[#ECEE07]" /> mkmetal1112@gmail.com</p>
            <p className="flex items-start"><MapPin size={20} className="mr-2 text-[#ECEE07] mt-1 flex-shrink-0" /> NO. 16-1 (1ST FLOOR), JALAN BALAKONG JAYA 6, TAMAN BALAKONG JAYA, 43200 BALAKONG, SELANGOR DARUL EHSAN.</p>
          </div>
        </div>
      </div>

      {/* Bottom Bar: Copyright & Legal */}
      <div className="border-t border-gray-700 mt-8 pt-6 text-center text-xs sm:text-sm text-gray-300 px-4">
        <p>&copy; {currentYear} MK Metal & Engineering Works. All Rights Reserved.</p>
        <p className="mt-1">Designed & Developed By- <a href="https://techvelly.com/" target="_blank" rel="noopener noreferrer" className="text-[#ECEE07] hover:underline">TechVelly.com</a></p>
        {/* <div className="flex justify-center space-x-4 mt-2">
          <a href="#" className="hover:text-[#ECEE07] transition-colors duration-300">Privacy Policy</a>
          <a href="#" className="hover:text-[#ECEE07] transition-colors duration-300">Terms of Use</a>
        </div> */}
      </div>
    </footer>
  );
};

export default Footer;
